import Reveal from '@/components/base/Reveal';
import { useToast } from '@/components/feature/ToastProvider';
import { rollingLeaks } from '@/mocks/homeData';

const toneClass: Record<string, string> = {
  primary: 'bg-primary-100 text-primary-800',
  secondary: 'bg-secondary-100 text-secondary-800',
  accent: 'bg-accent-100 text-accent-900',
};

export default function RollingFeed() {
  const { showToast } = useToast();

  return (
    <section id="rolling" className="bg-background-50">
      <div className="mx-auto w-full max-w-shell px-4 py-20 md:px-6 md:py-28">
        <Reveal>
          <div className="flex flex-col gap-6 md:flex-row md:items-end md:justify-between">
            <div className="max-w-2xl">
              <span className="inline-flex items-center gap-2 rounded-full bg-accent-100 px-3 py-1 text-xs font-medium text-accent-900">
                <i className="ri-broadcast-line" />
                滚动爆料
              </span>
              <h2 className="mt-5 font-heading text-2xl font-bold leading-snug text-foreground-950 md:text-4xl">
                最新消息一条条往下走，节奏快但看得清
              </h2>
              <p className="mt-4 text-sm leading-relaxed text-foreground-600 md:text-base">
                这里按时间顺序记录每一次更新。每条都标了来源和互动情况，方便你判断哪条值得先点开。
              </p>
            </div>
            <div className="flex items-center gap-2 whitespace-nowrap rounded-md border border-background-300/80 px-4 py-2.5 text-xs text-foreground-600">
              <span className="animate-live-dot h-1.5 w-1.5 rounded-full bg-primary-500" />
              正在监听更新 · 最近一次 20:12
            </div>
          </div>
        </Reveal>

        <Reveal delay={100}>
          <ul className="mt-12 border-t border-background-200/80">
            {rollingLeaks.map((leak) => (
              <li key={`${leak.time}-${leak.title}`}>
                <a
                  href="#rolling"
                  className="group flex flex-col gap-3 border-b border-background-200/80 py-5 transition-colors hover:bg-background-100 md:flex-row md:items-center md:gap-6 md:px-3"
                >
                  <span className="font-heading text-sm font-bold text-foreground-500 md:w-16 md:shrink-0 md:text-base">
                    {leak.time}
                  </span>
                  <span
                    className={`inline-flex w-fit items-center rounded-full px-2.5 py-0.5 text-xs font-medium ${toneClass[leak.tone]}`}
                  >
                    {leak.tag}
                  </span>
                  <span className="flex-1 text-sm leading-snug text-foreground-900 transition-colors group-hover:text-primary-600 md:text-base">
                    {leak.title}
                  </span>
                  <span className="flex items-center gap-4 text-xs text-foreground-500">
                    <span className="hidden items-center gap-1.5 md:flex">
                      <i className="ri-price-tag-3-line text-sm" />
                      {leak.source}
                    </span>
                    <span className="flex items-center gap-1.5">
                      <i className="ri-thumb-up-line text-sm" />
                      {leak.likes}
                    </span>
                    <span className="flex items-center gap-1.5">
                      <i className="ri-chat-3-line text-sm" />
                      {leak.comments}
                    </span>
                    <i className="ri-arrow-right-line hidden text-base text-foreground-400 transition-transform group-hover:translate-x-1 md:block" />
                  </span>
                </a>
              </li>
            ))}
          </ul>
        </Reveal>

        <Reveal delay={140}>
          <div className="mt-10 flex justify-center">
            <button
              type="button"
              onClick={() => showToast('演示环境：已展示最近 6 条更新')}
              className="inline-flex items-center gap-2 whitespace-nowrap rounded-md border border-background-300/80 px-6 py-3 text-sm font-medium text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-700"
            >
              <i className="ri-refresh-line text-base" />
              加载更早的爆料
            </button>
          </div>
        </Reveal>
      </div>
    </section>
  );
}